var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQr = function SvgIconQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.75H22.9167V14.5833H27.0833V20.8333H22.9167V22.9167H18.75V20.8333H14.5833V14.5833H18.75V18.75ZM0 14.5833H12.5V27.0833H0V14.5833ZM4.16667 18.75V22.9167H8.33333V18.75H4.16667ZM0 0H12.5V12.5H0V0ZM4.16667 4.16667V8.33333H8.33333V4.16667H4.16667ZM14.5833 0H27.0833V12.5H14.5833V0ZM18.75 4.16667V8.33333H22.9167V4.16667H18.75ZM22.9167 22.9167H27.0833V27.0833H22.9167V22.9167ZM14.5833 22.9167H18.75V27.0833H14.5833V22.9167Z",
    fill: "white"
  })));
};
export default SvgIconQr;